import React, { useState, useContext, useEffect } from "react";
import { initializePaddle } from "@paddle/paddle-js";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

function Paddlecheckout() {
  const [email, setEmail] = useState("");
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);
  
  
  const handleCheckout = async () => {
    const res = await fetch("http://localhost:8084/paddle-create-checkout", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email,
        productId: "pro_01jzwrcjfgc2g8hdfpeyyv5vf2",
      }),
    });

    const data = await res.json();

    if (data.success) {
      const paddle = await initializePaddle({
        environment: "sandbox",
        token: "", // Optional if you're not using Paddle tokens
      });

      paddle.Checkout.open({
        override: data.url,
      });
    } else {
      alert("Checkout failed.");
    }
  };

  return (
    <div style={{ padding: 40 }}>
      <h2>{t("SubscribeWithPaddle")}</h2>
      <input
        type="email"
        placeholder={t("EnterEmail")}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <br />
      <br />
      <button onClick={handleCheckout}>{t("StartSubscription")}</button>
    </div>
  );
}

export default Paddlecheckout;
